<template>
    <div class="grid-wrapper">
        <div class="dynamic-grid mt-4">
            <div v-for="(items, letter) in letterColumns" :key="letter" class ="column">
                <strong>{{ letter }}</strong>
                <div v-for="(item, index) in items" :key="index" class="pl-4 pr-4 pt-2 pd-2">{{ item }}</div>
            </div>
        </div> 
    </div>    
</template>




<script>
export default {
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    data() {
        return {}
    },
    watch: {

    },
    computed: {
        letterColumns() {
            const columns = {}
            const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
            this.items.forEach((item, index) => {
                const columnLetter = letters[index] || '?';
                if (!columns[columnLetter]) {
                    columns[columnLetter] = []
                }
                columns[columnLetter].push(item)
            })
            return columns
        }
    },
    methods: {
        
    },
};
</script>

<style scoped>

    .grid-wrapper {
        max-width: 750px;
        overflow-x: auto;
        padding-bottom: 8px;
        margin: 0 auto;
    }

    .dynamic-grid {
        display: inline-flex;
        flex-wrap: wrap;
        gap: 0; 
        margin-top: 20px;
        border-top: 1px solid #000; 
        border-bottom: 1px solid #000; 
        border-left: 1px solid #000; 
        background-color: #fff;
        min-width: max-content;
    }

    .column {
        display: flex;
        flex-direction: column;
        border-right: 1px solid #000;
        background-color: #fff;
    }

    .column strong {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: var(--v-primaryLighter-base);
    }

    .column > div {
        padding: 8px;
        border-top: 1px solid #000;
        text-align: center;
        background-color: #fff;
    }
</style>
